/**
 * Produce a safe PDF filename for uploads.
 * - S3 user-defined metadata must be ASCII / HTTP-header-safe (no unicode, control chars).
 * - Keeps: letters, digits, `.`, `_`, `-` (hyphens in names like `2025-roc` are kept).
 * - Normalizes unicode / NBSP / zero-width characters, then maps other symbols to `_`.
 */
export function sanitizeUploadFilename(
  original: string,
  options?: { maxBaseLength?: number }
): string {
  const maxBase = options?.maxBaseLength ?? 180;
  const trimmed = original.trim();
  if (!trimmed) {
    return `upload_${Date.now()}.pdf`;
  }

  const lastDot = trimmed.lastIndexOf('.');
  const baseRaw = lastDot > 0 ? trimmed.slice(0, lastDot) : trimmed;
  let ext = lastDot > 0 ? trimmed.slice(lastDot).toLowerCase() : '.pdf';
  if (ext !== '.pdf') {
    ext = '.pdf';
  }

  let base = baseRaw
    .normalize('NFKC')
    .replace(/\u00A0/g, ' ')
    .replace(/[\u200B-\u200D\uFEFF]/g, '');

  base = base
    .replace(/[^a-zA-Z0-9._-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^[._-]+|[._-]+$/g, '');

  if (!base) {
    base = `filing_${Date.now()}`;
  }

  base = base.slice(0, maxBase);
  return `${base}${ext}`;
}
